import todaysTTT from "./tuskytime.json"
import baboon from "./baboon.jpg"
import schoolonfire from "./schoolonfire.png"
import {useState} from 'react'
function getAdvisoryQuote() {
    const quotes = [
        "duh",
        "bro its wednesday",
        "you didn't need me to tell you that",
        "remember, wednesday = advisory",
        "you better get going!",
        "next time use brain plz",
        "duhhhh",
        "you will be advised whether you like it or not"
    ]
    return quotes[Math.floor(Math.random() * quotes.length)]
}

function TuskyTime(props) {
    let [offset, setOffset] = useState(0)

    const today = new Date(Date.now() + 8.64e+7 * offset);
    let todaysTT
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    if (dd < 10) dd = dd;
    if (mm < 10) mm = mm;
    const formattedToday = mm + '/' + dd
    let schoolDay = true
  
    
    try {
        
        todaysTT = todaysTTT[formattedToday]
        todaysTT.TT = todaysTT.TT != undefined ? todaysTT.TT.replace("TT ", "") : "No Tusky Time!"
    } catch(e) {
        console.log(e)
        schoolDay = false
    }
    if ((mm > 5) && (mm < 8)) {
        let e = true
        if (mm == 6 && dd < 16) {e = false} 
        if (e) {
            return (
                <div className="tuskytime">
                    <h2> bro it's summer why are you here you absolute nerd</h2>
                    <img src={schoolonfire}></img>
                </div>
            )
        } 
    }
    if (schoolDay == false) {
        return (
            
        <div className="tuskytime">
            <h3>Date: {formattedToday}</h3>
            <div className="buttons">
                <button id="offsetbutton" onClick={() => {setOffset(offset - 1)}}>{"<"}</button>
                <button id="offsetbutton" onClick={() => {setOffset(offset + 1)}}>{">"}</button>
            </div>
            <h2> there's no school today you absolute buffoon</h2>
            <img id="baboon" src={baboon}></img>
            <p>(you rn)</p>
        </div>
        )
    }
    function ifAdvisory() {
        if (todaysTT.TT == "Advisory") {
            return (<p>{getAdvisoryQuote()}</p>)
        }
    }
    return (
        <div className="tuskytime">
            <h3>Date: {formattedToday}</h3>
            <div className="buttons">
                <button id="offsetbutton" onClick={() => {setOffset(offset - 1)}}>{"<"}</button>
                <button id="offsetbutton" onClick={() => {setOffset(offset + 1)}}>{">"}</button>
            </div>
            <h3> TODAY IS A(N)  </h3>
            <div id="day-container">
                <h1 id='day'>{todaysTT.day}</h1>
                <p id="smallish-text">DAY</p>
            </div>
            <h3 id="tuskytimelabel"> AND IT'S TUSKY TIME </h3>
            <h1 id='day'>{todaysTT.TT}</h1>
            {ifAdvisory()}
        </div>
    )
}
export default TuskyTime